"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      borderTop: "1px solid ".concat(palette.divider),
      padding: spacing(3)
    },
    input: {
      display: 'none'
    },
    buttonUpload: {
      color: palette.link.main,
      border: "1px solid ".concat(palette.divider),
      backgroundColor: palette.common.white,
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: palette.grey.A200
      }
    },
    buttonRemoveHover: {
      '&:hover': {
        backgroundColor: palette.common.white
      }
    },
    buttonRemove: {
      color: palette.red.main
    },
    avatar: {
      margin: 10,
      width: 88,
      height: 88
    },
    buttonsBlocK: {
      marginLeft: spacing(4)
    }
  };
});
var MAX_AVATAR_SIZE = 5000 * 1024; // 5Mb

var ALLOWED_EXTENSIONS = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

var AvatarSetting = function AvatarSetting(_ref2) {
  var alt = _ref2.alt,
      image = _ref2.image,
      isLoading = _ref2.isLoading,
      onUpload = _ref2.onUpload,
      onRemove = _ref2.onRemove;
  var classes = useStyles();

  var _GlobalMessage$useGlo = _services.GlobalMessage.useGlobalMessage(),
      showGlobalMessage = _GlobalMessage$useGlo.showGlobalMessage;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var removeAvatarHandler = (0, _react.useCallback)(function () {
    setOpen(true);
  }, []);
  var handleClose = (0, _react.useCallback)(function () {
    setOpen(false);
  }, []);
  var fileChangedHandler = (0, _react.useCallback)(function (event) {
    var _ref3 = event.target.files || [],
        _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
        file = _ref4[0];

    if (!file) {
      return;
    }

    if (!ALLOWED_EXTENSIONS.exec(file.name)) {
      showGlobalMessage({
        type: 'error',
        text: 'Only .gif, .jpg, or .png file formats are supported'
      });
      return;
    }

    if (file.size > MAX_AVATAR_SIZE) {
      showGlobalMessage({
        type: 'error',
        text: 'The image may not be greater than 5000 kilobytes.'
      });
      return;
    }

    onUpload(file);
  }, [onUpload, showGlobalMessage]);
  var removeAvatarProcess = (0, _react.useCallback)(function () {
    setOpen(false);
    onRemove();
  }, [onRemove]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Dark-Bold"
  }, "Profile photo")), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    item: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    container: true,
    xs: 1,
    justifyContent: "center",
    alignItems: "center"
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, null) : /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    alt: alt,
    className: classes.avatar,
    src: image
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 4
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "contained-button-file"
  }, /*#__PURE__*/_react.default.createElement("input", {
    accept: "image/jpeg, image/png, image/gif",
    className: classes.input,
    id: "contained-button-file",
    multiple: true,
    type: "file",
    onChange: fileChangedHandler
  }), /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    component: "span",
    className: classes.buttonUpload
  }, "Change"))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    color: "primary",
    className: (0, _classnames.default)(classes.buttonRemove, classes.buttonRemoveHover, classes.buttonRoot),
    onClick: removeAvatarHandler
  }, "Remove"), /*#__PURE__*/_react.default.createElement(_material.Dialog, {
    open: open,
    onClose: handleClose,
    "aria-labelledby": "draggable-dialog-title"
  }, /*#__PURE__*/_react.default.createElement(_material.DialogTitle, {
    style: {
      cursor: 'move'
    },
    id: "draggable-dialog-title"
  }, "Please confirm remove your avatar"), /*#__PURE__*/_react.default.createElement(_material.DialogActions, null, /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: handleClose,
    color: "primary"
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: classes.buttonRemove,
    onClick: removeAvatarProcess,
    color: "primary"
  }, "Remove")))))));
};

AvatarSetting.propTypes = {
  alt: _propTypes.default.string.isRequired,
  image: _propTypes.default.string.isRequired,
  isLoading: _propTypes.default.bool.isRequired,
  onRemove: _propTypes.default.func.isRequired,
  onUpload: _propTypes.default.func.isRequired
};
var _default = AvatarSetting;
exports.default = _default;